// Design tokens shared across the unauthenticated/role-gate screens
// (Login, NoRoleAssigned). These pages run *outside* the MUI ThemeProvider
// or before role gating, so they can't rely on the theme alone and need
// raw values for things like document.body backgrounds and outer
// containers. Keep this list narrow — anything inside the MUI tree
// should still pull from `src/theme/index.ts`.
//
// This file is therefore the source of truth for the unauthenticated
// palette (the login screens run their own paper/serif look, which the app
// theme does not model), so its values are raw by design and opt out of
// the `lint:tokens` hex gate line by line.

export const AUTH_TOKENS = {
  bg: "#F6F4F1", // allow-hex
  bgElev: "#FFFFFF", // allow-hex
  ink: "#0E0D10", // allow-hex
  ink2: "#2A2830", // allow-hex
  muted: "#6B6875", // allow-hex
  line: "#E9E5DF", // allow-hex
  warn: "#C24A1A", // allow-hex
  ok: "#2F7D4E", // allow-hex
  radius: "18px",
  radiusSm: "12px",
  shadowCard:
    "0 1px 0 rgba(14,13,16,0.04), 0 30px 60px -30px rgba(14,13,16,0.18), 0 14px 30px -18px rgba(194,65,12,0.18)", // allow-hex
  fontSans:
    '"Source Sans 3", "Source Sans Pro", ui-sans-serif, system-ui, -apple-system, "Segoe UI", sans-serif',
  fontSerif: '"Instrument Serif", ui-serif, Georgia, serif',
  fontMono:
    '"JetBrains Mono", ui-monospace, SFMono-Regular, Menlo, monospace',
} as const;
